import { NextPage } from 'next'
import Head from 'next/head'
import Link from 'next/link'
import { useTranslation } from 'react-i18next'
import IconHelp from '~/assets/images/landing-help.svg'
import IconUse1 from '~/assets/images/landing-use-1.svg'
import IconUse2 from '~/assets/images/landing-use-2.svg'
import IconUse3 from '~/assets/images/landing-use-3.svg'
import IconWhat from '~/assets/images/landing-what.svg'
import IconWhy from '~/assets/images/landing-why.svg'
import IconLearnMore from '~/assets/images/learn-more.png'
import IconLitePaper from '~/assets/images/lon-litepaper.svg'
import Footer from '~/components/Footer'
import Header from '~/components/Header'
import { ASSET_PREFIX } from '~/constants/env'
import { useGA } from '~/hooks'
import { LOCALES } from '~/locales'
import {
  EconomicMechanism,
  LonDashboard,
  RoadMap,
  SystemDesign,
} from './components'
import { StyledAboutLon } from './styled'

const Overview: NextPage = () => {
  const { i18n, t } = useTranslation()
  const isZh = i18n.resolvedLanguage === LOCALES.ZH
  const { trackElClick } = useGA()

  const targetLitePaper = isZh
    ? `${ASSET_PREFIX}/files/Tokenlon-Litepaper_zh-cn.pdf`
    : `${ASSET_PREFIX}/files/Tokenlon-litepaper_en-us.pdf`

  const questionLink = isZh
    ? 'https://tokenlon.zendesk.com/hc/zh-cn/sections/360010619151'
    : 'https://tokenlon.zendesk.com/hc/en-us/sections/360010619151'

  return (
    <>
      <Head>
        <title>{t('meta_lon_about_title')}</title>
        <meta name="description" content={t('meta_lon_about_description')} />
        <meta name="keywords" content={t('meta_lon_keywords')} />
      </Head>
      <Header />
      <StyledAboutLon>
        <main>
          <section className="landing-s1">
            <div className="s-inner">
              <div>
                <div
                  className={`s1-left-inner s1-left-inner-${
                    isZh ? 'zh' : 'en'
                  }`}
                >
                  <h1 className="landing-title">
                    <span>{t('lon_landing_page_title')}</span>
                    <div className="lon-landing-page-division" />
                    <span>{t('connect_user_and_participants')}</span>
                  </h1>
                  <div className="landing-description">
                    {t('lon_lading_page_description')}
                  </div>
                  <Link href="/instant">
                    <a
                      className="btn-1"
                      data-trackid="webtl_overview_trade"
                      data-trackdata={JSON.stringify({ url: '/instant' })}
                      onClick={trackElClick}
                    >
                      {t('participate_in_trade')}
                    </a>
                  </Link>
                  <Link href="/lon/dashboard">
                    <a
                      className="btn-1"
                      data-trackid="webtl_overview_dashboard"
                      data-trackdata={JSON.stringify({ url: '/lon/dashboard' })}
                      onClick={trackElClick}
                    >
                      {t('visited_mining_data')}
                    </a>
                  </Link>
                </div>
              </div>
              <img src={IconWhat} alt="Lon" />
            </div>
          </section>

          <section className="landing-s2">
            <div className="s-inner">
              <div>
                <img src={IconWhy} alt="why" />
              </div>
              <div>
                <div>
                  <h2>{t('why_choise_lon')}</h2>
                  <dl>
                    <dt>
                      <i />
                      {t('flow_inlet')}
                    </dt>
                    <dd>{t('millions_user_support')}</dd>
                    <dt>
                      <i />
                      {t('trading_volume')}
                    </dt>
                    <dd>{t('top3_dex')}</dd>
                    <dt>
                      <i />
                      {t('high_success_rate')}
                    </dt>
                    <dd>{t('leading_dex_protocol')}</dd>
                  </dl>
                </div>
              </div>
            </div>
          </section>
          <LonDashboard />
          <section className="landing-s3">
            <div className="s-inner">
              <h2>{t('what_can_lon_do')}</h2>
              <ul>
                <li>
                  <img src={IconUse1} alt="" />
                  <h3>{t('incentive')}</h3>
                  <p>{t('participants_can_get_lon')}</p>
                </li>
                <li>
                  <img src={IconUse2} alt="" />
                  <h3>{t('trade_discount')}</h3>
                  <p>{t('fee_discount')}</p>
                </li>
                <li>
                  <img src={IconUse3} alt="" />
                  <h3>{t('governance')}</h3>
                  <p>{t('governance_make_tokenlon_better')}</p>
                </li>
              </ul>
            </div>
          </section>

          <SystemDesign />
          <EconomicMechanism />
          <RoadMap />

          <div className="landing-questions">
            <div className="lon-faq-item">
              <div>
                <img src={IconHelp} alt="help" />
                <div className="landing-questions-info">
                  <h4>{t('lon_fqa')}</h4>
                  <Link href={questionLink}>
                    <a
                      data-trackid="webtl_overview_qa"
                      data-trackdata={JSON.stringify({ url: questionLink })}
                      onClick={trackElClick}
                    >
                      {t('learn_trading_mining')}
                    </a>
                  </Link>
                </div>
              </div>
              <a href={questionLink}>
                <img src={IconLearnMore.src} />
              </a>
            </div>

            <div className="lon-faq-item">
              <div>
                <img src={IconLitePaper} alt="help" />
                <div className="landing-questions-info">
                  <h4>{t('LON_litepaper')}</h4>
                  <a
                    href={targetLitePaper}
                    target="_blank"
                    data-trackid="webtl_overview_litepaper"
                    data-trackdata={JSON.stringify({ url: targetLitePaper })}
                    onClick={trackElClick}
                  >
                    {t('LON_litepaper_description')}
                  </a>
                </div>
              </div>
              <a href={targetLitePaper} target="_blank">
                <img src={IconLearnMore.src} />
              </a>
            </div>
          </div>
        </main>
      </StyledAboutLon>
      <div className="footer-wrap">
        <Footer />
      </div>
    </>
  )
}

export default Overview
